import { gql } from "@apollo/client";

export const APPLY_ENFORCEMENT_INTENT_CORRECTION = gql`
  mutation ApplyEnforcementIntentCorrection(
    $intentId: uuid!
    $licensePlateNumber: String!
    $licensePlateRegion: String!
  ) {
    appliedCorrection: apply_enforcement_intent_correction(
      intent_id: $intentId
      license_plate_number: $licensePlateNumber
      license_plate_region: $licensePlateRegion
    ) {
      correction {
        id
      }
    }
  }
`;

export interface ApplyEnforcementIntentCorrectionData {
  appliedCorrection: {
    correction: {
      id: string;
    };
  };
}

export interface ApplyEnforcementIntentCorrectionVars {
  intentId: string;
  licensePlateNumber: string;
  licensePlateRegion: string;
}

export default APPLY_ENFORCEMENT_INTENT_CORRECTION;
